import React, { FC } from "react"
import {
    Button,
    Card,
    Center,
    Image,
    PasswordInput,
    Space,
    Stack,
    TextInput,
    Title,
    useMantineTheme,
} from "@mantine/core"
import EcomoniLogo from "../../../../assets/logos/ecomoni_logo.svg"
import { useDisclosure } from "@mantine/hooks"
import useSignInWithPassword from "./useSignInWithPassword"
import { ForgotPasswordModal } from "../forgot-password-modal/ForgotPasswordModal"
import { useLanguage } from "../../../../contexts/language-context"

type SignInCardProps = unknown

const SignInCard: FC<SignInCardProps> = () => {
    const theme = useMantineTheme()
    const { form, signInWithPassword, loading } = useSignInWithPassword()
    const { L } = useLanguage()
    const [opened, { open, close }] = useDisclosure(false)

    return (
        <Card
            shadow="xl"
            px={{ base: `calc(2 * ${theme.spacing.xl})`, xs: "xl" }}
            py={`calc(2 * ${theme.spacing.xl})`}
            w={{ base: "100%", xs: theme.breakpoints.xs }}
            withBorder
        >
            <form onSubmit={form.onSubmit(signInWithPassword)}>
                <Stack spacing="xl">
                    <Center>
                        <Image src={EcomoniLogo} width={`calc(4 * ${theme.spacing.xl})`} />
                    </Center>
                    <Space />
                    <Title order={3} align="center">
                        Sign into Ecomoni
                    </Title>
                    <Space />
                    <TextInput
                        variant="filled"
                        type="email"
                        size="md"
                        placeholder={L("Email address")}
                        required
                        {...form.getInputProps("email")}
                    />
                    <PasswordInput
                        variant="filled"
                        size="md"
                        placeholder={L("Password")}
                        required
                        {...form.getInputProps("password")}
                    />
                    <Space />
                    <Button size="md" type="submit" loading={loading}>
                        {L("Login")}
                    </Button>
                    <Button variant="subtle" size="sm" onClick={open}>
                        {L("Forgot password")}
                    </Button>
                </Stack>
            </form>
            <ForgotPasswordModal opened={opened} onClose={close} />
        </Card>
    )
}

export default SignInCard
